import { StyledLink, StyledSpan } from './styles';

import Link from 'next/link';
import prepInternalUrl from '@/lib/prepInternalUrl';

const NavLink = ({ children, to, active = false, ...props }) => {
  if (!to) {
    return <StyledSpan>{children}</StyledSpan>;
  }

  const fixedUrl = prepInternalUrl(to) || '';
  return (
    <Link href={fixedUrl} passHref legacyBehavior>
      <StyledLink active={active} onClick={(ev) => props.onClose && props.onClose(ev)} {...props}>
        {children}
      </StyledLink>
    </Link>
  );
};

export default NavLink;
